import { GuidLink, type GuidLinkProps } from "../../../shared/GuidLink";
import { getPath } from "./ReportDetailsPath";

export interface ContractDetailsLinkProps
  extends Omit<GuidLinkProps, "children" | "to" | "value" | "name"> {
  reportId: string;
}

export function ReportDetailsLink({
  reportId,
  ...props
}: ContractDetailsLinkProps) {
  return (
    <GuidLink
      to={getPath(reportId)}
      {...props}
      title={`Details for contract ${reportId}`}
    >
      {reportId}
    </GuidLink>
  );
}
export function ReportQueryDetailsLink({
  reportId,
  ...props
}: ContractDetailsLinkProps) {
  return (
    <GuidLink
      to={getPath(reportId)}
      {...props}
      title={`Details for contract ${reportId}`}
    >
      {reportId}
    </GuidLink>
  );
}
